export const heTranslation = {
  "site_name": "Enigma Hotels",
  "transfer": {
    "distance": "מרחק",
    "transfer": "העברה",
    "s": "העברות",
    "pickup": "יציאה מ",
    "dropoff": "נחיתה ב",
    "time": "שעה",
    "max_people": "מקסימום <span class=\"text-bold\">{{count}} אנשים</span></br> לרכב",
    "max_suitcases": "מקסימום <span class=\"text-bold\">{{count}} מזוודות</span></br> לרכב",
    "est_time": "זמן משוער </br><span class=\"text-bold\">{{h}} {{min}}</span>",
    "select_transfer": "בחר את ההעברה שלך מ",
    "arrival_details": "פרטי ההגעה",
    "return_details": "פרטי החזרה",
    "vehicle": "רכב",
    "from": "מ",
    "to": "אל",
    "choose_return": "יש לבחור העברה חזור! <br /> {{from}} אל {{to}}",
    "choose_arrival": "יש לבחור העברה הלוך! <br /> {{from}} אל {{to}}",
    "continue_book": "המשך להזמין",
    "pay_via_cc": "שלם באמצעות כרטיס אשראי",
    "details": "פרטי העברה",
    "arrival_info": "מידע הגעה",
    "return_info": "מספקים פרטים",
    "addresses": "כתובות",
    "airports": "שדות תעופה",
    "diff_countries": "שימו לב! נקודות ההתחלה והסיום נמצאות במדינות שונות.",
    "from_search": "מאיפה לאסוף",
    "to_search": "איפה להוריד",
    "pick_up_date": "תאריך לאיסוף",
    "pick_up": "לאיסוף"
  },
  "hotel_info": "מידע על המלון",
  "dyn": {
    "dynamic": "ספורט & מוזיקה",
    "predefined": "חבילה מומלצת",
    "self": "חבילה דינמית",
    "event_type": "סוג אירוע",
    "event_music": "יעד / אמן / פסטיבל",
    "event_sport": "יעד / קבוצה / ליגה",
    "sport_type": "סוג ספורט",
    "people": "אנשים",
    "sport": "ספורט",
    "music": "מוזיקה",
    "package_details": "פרטי החבילה",
    "ticket": "כרטיס",
    "from_here": "מכאן",
    "your_choice": "הבחירה שלך",
    "extra_money": "תוספת לכל נוסע",
    "filter_results": "סנן תוצאות חיפוש",
    "not_found": "האטרקציה לא נמצאה",
    "fl_htl_ticket": "טיסה + מלון + כניסה",
    "fl_pl_htl": "טיסה + מלון",
    "image_for_illustration": "תמונת האיצטדיון/אולם להמחשה בלבד",
    "supplement_card": "תוספת לכרטיס",
    "card_category": "קטגורית הכרטיס",
    "to_order": "להזמנה",
    "outbound_flight": "טיסה הלוך",
    "return_flight": "טיסה חזור",
    "card": "פרטי הכרטיס",
    "tickets_amount": "כמות הכרטיסים",
    "ticket_date": "מועד האירוע",
    "terms": "תנאי שימוש באתר",
    "general_conditions": "תנאים כלליים ודמי ביטול",
    "its_your_read": "באחריותך לקרוא את",
    "general_conditions_cancellation": "תנאים כלליים וביטולים",
    "all_conditions_time": "ואת כל התנאים והגבלות לגבי הזמנך",
    "the_event_ticket": "כרטיס האירוע",
    "full_cancellation_fees": "בדמי ביטול מלאים",
    "no_cancellation_fees": "ללא דמי ביטול עד ליום",
    "handling_fees": "דמי טיפול",
    "cancellation_50": "עבור הטיפול בביטול הזמנה תגבה חברת טיולים 50$ לכל נוסע מעבר לדמי הביטול של הספקים השונים",
    "from_the_moment": "מרגע ביצוע ההזמנה",
    "add_forward_transfer": "הוסף העברה משדה התעופה למלון",
    "add_two_way_transfer": "הוסף העברה משדה התעופה למלון ובחזרה",
    "arrival_transfer": "העברה משדה התעופה למלון",
    "return_transfer": "העברה ממלון לשדה התעופה",
    "no_avail": "מצטערים שלא מצאנו חבילה זמינה",
    "search_again": " חפשו שוב",
    "fl_htl": "טיסה + מלון",
    "select_fare": "בחר{{from}} תעריף ל{{to}}",
    "change_fare": "שנה תעריף",
    "per_passenger": "לנוסע",
    "hotel_not_found": "מלון לא נמצא",
    "flight_not_found": "טיסה לא נמצאה",
    "error": "משהו השתבש",
    "attraction_not_found": "אטרקציה לא נמצאה",
    "tlv": "תל אביב",
    "event_date_warning": "תאריך האירוע חייב להיות בתוך טווח התאריכים שנבחרו",
    "choose_room": "בחר חדר",
    "event": "אירוע",
    "packages": "חבילות דינמיות",
    "there_is_no_any_room_please_choose_another_hotel": "אין חדרים זמינים, נא לבחור מלון אחר"
  },
  "ALP24F": "שכר",
  "AMS24": "סדיר",
  "tlv": "TLV - תל אביב",
  "flight": {
    "flight": "טיסה",
    "s": "טיסות",
    "from": "יציאה מ",
    "to": "נחיתה ב",
    "departing": "תאריך יציאה",
    "returning": "תאריך חזרה",
    "date": "תאריך",
    "choose_persons": "בחר נוסעים",
    "dates": "תאריכים",
    "details": " פרטי הטיסה",
    "class": "מחלקה",
    "economy": "תיירים",
    "business": "עסקים",
    "economy_premium": "מחלקה פרימיום",
    "baggage": "כבודה",
    "round_trip": "הלוך חזור",
    "one_way": "כיוון אחד",
    "multiple_destinations": "ריבוי יעדים",
    "found_from": "טיסות שנמצאו מ ",
    "details_segment": " פירוט מקטעי הטיסה",
    "forward": "הלוך",
    "total_price": "מחיר כולל לעסקה",
    "avarage_per_passenger": "סה\"כ ממוצע לנוסע",
    "seats_available": "מקומות פנויים",
    "no_suitcases_allowed": "אין ניתן להיכנס עם מזוודות",
    "airline_allow_one": "חברת התעופה מתירה מזוודה אחת",
    "airline_allow_multiple": "חברת התעופה מתירה {{count}} מזוודות",
    "airline_allow_max": "חברת התעופה מתירה מזוודה במשקל של עד {{weight}}",
    "outbound": "הלוך",
    "inbound": "חזור",
    "direct_only": "טיסות ישירות",
    "order_details": "פרטי ההזמנה",
    "order_summary": "סיכום ההזמנה",
    "departure_date": "תאריך יציאה",
    "return_date": "תאריך חזרה",
    "usa_warning": "יש לשים לב במקרה מעבר או עצירה בארצות הברית יש חובה לויזה אפילו אם מדובר בטיסה המשך, באחריות הלקוח להנפיקה.",
    "total_average_passenger": "סה\"כ ממוצע לנוסע",
    "total_per_package": "מחיר כולל לעסקה",
    "departure": "יציאה",
    "return": "חזרה",
    "departure_time": "שעת המראה",
    "departure_airport": "נמל יציאה",
    "arrival_time": "שעת נחיתה",
    "arrival_airport": "הגעה לשדה",
    "aircraft": "מטוס",
    "seats_available_up": "מקומות פנויים",
    "show_details": "הצג פירוט",
    "frequent_flyer_airline": "מספר נוסע מתמיד בחברת התעופה",
    "frequent_flyer_number": "מספר נוסע מתמיד",
    "updgrade": "שדרג את הטיסה שבחרת",
    "info_and_conditions": "מידע ותנאים כלליים",
    "it_is_your": "באחריותך לקרוא ",
    "all_rules": "את כל החוקים וההגבלות ",
    "according_this": " שיש לטיסה זו",
    "booking_summary": "סיכום ההזמנה",
    "airport": "שדה תעופה",
    "service_time": "זמן שירות",
    "pickup_time": "זמן איסוף",
    "additional_info": "מידע נוסף",
    "number": "מספר טיסה",
    "to_airport": "לשדה תעופה",
    "handbag_excluded": "ללא כבודת יד",
    "handbag_included": "כבודת יד",
    "trolley_excluded": "ללא טרולי",
    "trolley_included": "טרולי קטן",
    "bag_included": "מזוודה",
    "bag_excluded": "ללא מזוודה",
    "airline_desc_and": "תיאור חברת תעופה וקישור",
    "link": "קישור",
    "airline": "חברת תעופה",
    "dep_time": "שעת יציאה",
    "arr_time": "שעת הגעה",
    "dep_airport": "נמל יציאה",
    "arr_airport": "נמל הגעה",
    "elapsed_time": "זמן טיסה",
    "all_baggage_information_on_the_airline_website": "כל נתוני הכבודה המוצגים באתר נקבעים על ידי חברת התעופה. לכן, יש לקרוא בעיון את האמור בקישור",
    "operated_by": "מופעל על ידי",
    "base": "בסיס",
    "tax": "מס",
    "SFM": "SFM",
    "book_2": "הזמן שני טיסות",
    "professional_mode": "מצב מעביד",
    "client_mode": "מצב לקוח",
    "incl_handbag": "כבודת יד כוללת",
    "incl_suitcase": "מזוודה כוללת",
    "incl_bag": "כבודה כוללת",
    "incl_baggage": "כבודה כוללת {{price}}",
    "incl_suitcase_kg": "מזוודה כוללת {{kg}} ק\"ג",
    "no_baggage": "ללא כבודה",
    "incl_handbag_kg": "כבודת יד כוללת {{kg}} ק\"ג",
    "without_handbag": "ללא כבודת יד",
    "add_another_flight": "הוסף טיסה"
  },
  "hotel": {
    "area": "אזור",
    "phone": "טלפון",
    "rating": "דירוג",
    "images": "תמונות",
    "remove_preffered": "הסר מהמועדפים",
    "hotel": "מלון",
    "s": "מלונות",
    "found_from": "מלונות שנמצאו",
    "full_cancellation_fee": "דמי ביטול מלאים",
    "free_cancel_before": "ביטול בחינם לפני",
    "show_rooms": "הצגת חדרים",
    "show_all_rooms": "הצג את כל החדרים",
    "boarding": "בסיס אירוח",
    "refund_limit": "דמי ביטול",
    "refund_price": "מחיר החזר",
    "nights": "לילות",
    "rooms": "חדרים",
    "room": "חדר",
    "room_details": "פרטי החדר",
    "nights_up": "מס' לילות",
    "select_room": "בחר את החדר שלך",
    "filter": "סנן...",
    "location": "מיקום המלון",
    "book": "הזמן",
    "overview": "סקירה",
    "facilities": "מתקני המלון",
    "details": "פרטי המלון",
    "dates": "תאריכים",
    "name": "שם מלון",
    "non_refundable": "לא ניתן להחזר",
    "rooms_prices": " חדרים ומחירים ({{count}})",
    "desc": " תיאור המלון",
    "fac": " מתקנים",
    "gallery": " גלריה",
    "choose_rooms": "בחר חדרים",
    "single_room": "1 חדר - {{price}}",
    "multi_rooms": "{{count}} חדרים - {{price}}",
    "rooms_price": "חדרים ומחירים",
    "paxes": "הרכב החדר",
    "room_type": "סוג החדר",
    "room_types": "סוגי חדרים",
    "more_room_types": "{{count}} סוגי חדרים נוספים",
    "description": "תיאור",
    "address": "כתובת",
    "loc": "מיקום",
    "hotel_facilities": "מתקני המלון",
    "room_facilities": "מתקני החדרים",
    "please_note": "שים לב!",
    "you_can_choose": "אתה יכול לבחור עד {{count}} נוסעים",
    "we_suggestion": "מצאנו הצעות נוספות עבורך",
    "max_rooms": "אנא בחר לא יותר מ {{count}} חדרים",
    "max_paxes": "אנא בחר לא יותר מ {{count}} נוסעים",
    "specific_out": "החדר המבוקש תפוס, הנה אלטרנטיבות",
    "select_rooms": "בחר חדרים",
    "info": "מידע על מלון",
    "checking_room_availability": "בודק זמינות חדר...",
    "one_hotel_search_failed": "החדר שבחרת לא זמין, אנא בחר חדר אחר",
    "price_per_night": "מחיר ללילה",
    "grp": "קבוצה",
    "brd": "בסיס אירוח",
    "bdr": "חדר שינה",
    "typ": "סוג",
    "vew": "נוף",
    "bed": "מיטה",
    "ada": "נגישות",
    "pax": "נוסעים",
    "cat": "קטגוריה",
    "blc": "מרפסת",
    "cap": "קיבולת",
    "sgl": "שימוש יחיד",
    "shr": "משותף",
    "filter_room_type": "סנן לפי סוג חדר",
    "open_fitler": "פתח",
    "show_room_types": "הצג סוגי חדרים",
    "hide_room_types": "הסתר סוגי חדרים",
    "pay_credit_card": "שלם באמצעות כרטיס אשראי",
    "paid_successfully": "שולם בהצלחה",
    "group_rooms": "קבץ חדרים",
    "ungroup_rooms": "בטל קיבוץ חדרים",
    "make_the_rooms_white": "הפוך את החדרים ללבנים",
    "make_the_rooms_colored": "הפוך את החדרים לצבעוניים",
    "supplier": "ספק",
    "order_summary": "סיכום הזמנה",
    "with_meal": "עם ארוחה",
    "meal": "ארוחה",
    "display_settings": "הגדרות תצוגה",
    "room_display": "תצוגת חדרים",
    "clear_room_name": "נקה את שם החדר",
    "filter_rooms": "סנן חדרים",
    "our_lowest_prices": "המחירים הנמוכים ביותר שלנו",
    "show_cube_design": "הצג עיצוב קובייתי",
    "show_cube_design_by_eat": "הצג עיצוב קובייתי לפי ארוחה",
    "show_rooms_in_tab": "הצג חדרים בכרטיסיות",
    "is_short_mode": "מצב קצר",
    "company_id": "מספר חברה",
    "rem_condition": "מצב הערות",
    "remarks": "הערות",
    "backoffice_trip": "משרד אחורי/מספר נסיעה:",
    "cancellation_policy": "מדיניות ביטול",
    "sales_price": "מחיר מכירה",
    "percent": "אחוז",
    "amount": "סכום",
    "professional": "מקצועי",
    "client": "לקוח",
    "professional_single": "סוכן - שורה בודדת",
    "professional_single_multi": "סוכן - שורה בודדת (מחיר מרובה)",
    "professional_single_2": "סוכן - שורה בודדת לחדר",
    "loca": "מיקום",
    "professional_v1": "מקצועי V1",
    "professional_v2": "מקצועי V2",
    "professional_v3": "סוכן - בסיס/קטגוריה",
    "business_new": "עסקי - בסיס/קטגוריה",
    "price_new": "עסקי - קטגוריה/סוג",
    "professional_v3_multi": "סוכן - בסיס/קטגוריה (מחיר מרובה)",
    "business_new_multi": "עסקי - בסיס/קטגוריה (מחיר מרובה)",
    "price_new_multi": "עסקי - קטגוריה/סוג (מחיר מרובה)",
    "professional_v4": "סוכן - קטגוריה/סוג",
    "professional_v4_multi": "סוכן - קטגוריה/סוג (מחיר מרובה)",
    "bussiness": "עסקי",
    "display_mode": "מצב תצוגה",
    "room_mode": "מצב חדר",
    "internal": "פנימי",
    "tab": "כרטיסייה",
    "config_saved": "ההגדרות נשמרו",
    "room_changed_after_one_hotel_search": "החדר שונה לאחר חיפוש מלון אחד",
    "get_serialiezed_config": "קבל תצורה מסודרת",
    "serialized_config_clipboard": "הגדרות מסודרות הועתקו ללוח",
    "center_me": "מרכז אותי",
    "focus": "פוקוס",
    "pin_this_item": "נעץ פריט זה",
    "room_status": "מצב החדר",
    "about_room": "אודות החדר",
    "room_info": "מידע על החדר",
    "preffered": "הגדרות מועדפות",
    "excluded": "הגדרות מוחקות",
    "preferred_saved": "הגדרות מלון מועדפות נשמרו",
    "language": "שפה",
    "positive_reviews": "ביקורות חיובי",
    "negative_reviews": "ביקורות שלילי",
    "price_breakdown": "פירוט מחיר",
    "non_ref": "לא ניתן להחזר",
    "rooms_were_not_found": "לא נמצאו חדרים",
    "add_special_request": "הוסף בקשה מיוחדת",
    "please_add_special_request": "אנא הוסף בקשה מיוחדת",
    "sorry_we_cant_find_hotel_here": "מצטערים, לא מצאנו מלון כאן",
    "we_are_checking_for_better_rates": "אנחנו בודקים אחרי מחירים טובים יותר",
    "we_are_waiting_for_the_chosen_room": "אנחנו ממתינים לחדר שנבחר",
    "original_room_description": "תיאור החדר המקורי",
    "hotel_reservation_in_process": "הזמנת מלון בתהליך",
    "number_of_persons": "מספר נוסעים",
    "search_room": "חיפוש חדר",
    "google": "Google",
    "tripadvisor": "Tripadvisor",
    "monitor": "Monitor",
    "copy": "העתק",
    "proposal": "הצעה",
    "find_nearly": "מצא בקרבת מקום",
    "preferred_hotel": "מלון מועדף",
    "system_recommended": "מומלץ על ידי המערכת",
    "travel_agent_recommended": "מומלץ על ידי סוכן נסיעות",
    "client_recommended": "מומלץ על ידי הלקוח",
    "stars": "כוכבים",
    "search": "חיפוש בעיצומו",
    "prices": "מחירים",
    "reviews": "ביקורות",
    "photos": "תמונות",
    "positive": "חיובי",
    "neutral": "נייטרלי",
    "negative": "שלילי",
    "rated_by_reviews": "מומלץ על ידי {{rating}} ביקורות",
    "filter_by_room_type": "סנן לפי סוג חדר",
    "reservation_is_refundable": "ההזמנה ניתנת להחזר בהתאם לכללי מחיר/תעריף.",
    "reservation_is_not_refundable": "ההזמנה אינה ניתנת להחזר בהתאם לכללי מחיר/תעריף.",
    "choose_up_to_5_cards": "בחר עד 5 כרטיסים",
    "multi_payment": "מספר תשלומים",
    "please_apply_every_price": "אנא הפעיל כל מחיר",
    "please_enter_valid_price": "אנא הזן מחיר תקין",
    "view_1": "תצוגה 1",
    "view_2": "תצוגה 2",
    "display_style": "סטייל תצוגה",
    "positive_reviews_tags": "תגיות ביקורות חיוביות",
    "negative_reviews_tags": "תגיות ביקורות שליליות",
    "ai_notes": "הערות AI",
    "hotel_type": "סוג מלון",
    "apartment": "דירה",
    "villa": "בית קור",
    "view_on_website": "אתר מלון"
  },
  "proposal": {
    "s": "הצעות",
    "remove_proposal": "הסיר הצעה",
    "max_images_selected": "הסכמתם על הצגת המספר המרבי של תמונות",
    "proposal_removed": "הצעה הוסרה",
    "display_order": "סדר הצגת המוצר",
    "proposal": "הצעת מחיר",
    "no": "אין הצעות",
    "download_pdf": "הורד PDF",
    "send_email": "שלח במייל",
    "create": "צור הצעה",
    "clear_all": "נקה הכל",
    "write_comments": "כתוב את ההערות שלך כאן...",
    "reviews": "ביקורות",
    "created": "ההצעה נוצרה",
    "show_price": "הצג מחיר",
    "please_select_rooms": "אנא בחר חדרים",
    "update": "עדכן",
    "update_all": "עדכן הכל",
    "fixed_value": "ערך קבוע",
    "percentage": "אחוז",
    "edit_price": "עריכת מחיר",
    "value": "ערך",
    "add_to": "הוסף להצעה",
    "details": "פרטים",
    "amenities": "מתקנים",
    "all_of_images": "כל התמונות",
    "dep": "פרטי יציאה",
    "dep_airport": "פרטי יציאה מהמטוס",
    "arr": "פרטי יעד",
    "arr_airport": "פרטי יעד מהמטוס",
    "dynamic": "דינאמי",
    "generated_by_user": "נוצר על ידי המשתמש",
    "created_at": "ת. יצירה",
    "flight_and_hotel": "טיסה ומלון",
    "google_images": "מידע חשוב: התמונות ממלונות Google",
    "customize": "התאמה אישית",
    "simple_template": "תבנית פשוטה",
    "colorful_template": "תבנית צבעונית",
    "contrast_template": "תבנית בהבדלים",
    "room_price_option": "אופציית מחיר החדרים",
    "description": "תיאור",
    "edit": "עריכת הצעה",
    "some_of_the_products_were_expired": "חלק מהמוצרים תם התפוגה",
    "by_order_id": "לפי מספר הזמנה #",
    "by_service_date": "לפי תאריך שירות",
    "original": "מקורי",
    "overwrite_price": "שכתוב מחיר",
    "discount_hotel_limit": "הנחה מלון מוגבל {{minPrice}}",
    "save": "שמור הצעה",
    "whatsapp_message": "אנא מצאו את המסמך של ההצעה שלכם.",
    "telegram_message": "אנא מצאו את המסמך של ההצעה שלכם.",
    "show_cancellation_date": "הצגת תאריך ביטול",
    "cancellation_date_delta": "תאריך ביטול פחות ימים",
    "ai_hotel_info": "מידע מלון AI",
    "item_view": "תצוגת פריט",
    "trip_view": "תצוגת טיול"
  },
  "map": {
    "list": "רשימה",
    "map": " מפה",
    "show": "הצג מפה"
  },
  "osm": {
    "uturn": "פנה U-turn",
    "sharp_right": "פנה בחדות ימינה",
    "right": "פנה ימינה",
    "slight_right": "פנה מעט ימינה",
    "straight": "",
    "slight_left": "פנה מעט שמאלה",
    "left": "פנה שמאלה",
    "sharp_left": "פנה בחדות שמאלה",
    "turn": "בצומת ב{{distance}}.",
    "new_name": "המשך ישר כאשר שם הדרך משתנה ל-{{name}}.",
    "depart": "התחל ממקום זה.",
    "arrive": "הגעת ליעד שלך ב-{{name}}.",
    "merge": "והצטרף ל{{name}}.",
    "on_ramp": "וקח את הנתיב המוביל ל{{name}}.",
    "off_ramp": "וקח את היציאה ל{{name}}.",
    "fork": "בפיצול בדרך ב{{name}}.",
    "end_of_road": "כאשר הדרך נגמרת ב{{distance}}.",
    "use_lane": "ושמור על הנתיב המצביע ב{{name}}.",
    "continue": "המשך ל{{distance}} ב{{name}}.",
    "roundabout": "והכנס למעגל התנועה ב{{name}} ב{{distance}}.",
    "rotary": "והכנס לרוטרי ב{{name}} ב{{distance}}.",
    "roundabout_turn": "וקח את היציאה המצוינת במעגל התנועה ב{{name}} ב{{distance}}.",
    "notification": "מידע חשוב לפניך ב{{name}} ב{{distance}}.",
    "exit_roundabout": "וצא מהמעגל התנועה ב{{name}} ב{{distance}}.",
    "exit_rotary": "וצא מהרוטרי ב{{name}} ב{{distance}}."
  },
  "bed_filter": {
    "title": "סנן לפי חדר",
    "pin_only": "רק נעוצים"
  },
  "assistant": {
    "tab_tooltip": "עוזר AI",
    "greeting": "שאלו על מלונות או טיסות, לדוגמה: \"טיסות לפריז בשבוע הבא\" או \"מלונות 5 כוכבים עם ארוחת בוקר\".",
    "placeholder": "שאלו על מלונות או טיסות…",
    "connecting": "מתחבר…",
    "send": "שלח",
    "connection_error": "לא ניתן להתחבר לעוזר. נסו שוב.",
    "send_error": "לא ניתן לשלוח את ההודעה. נסו שוב.",
    "loading": "טוען…",
    "session": "שיחה",
    "copy_session_id": "העתק מזהה שיחה",
    "copied": "הועתק",
    "model": "מודל AI",
    "session_viewer": "מציג שיחות",
    "results_opened": "התוצאות מוצגות בעמוד",
    "search_failed": "לא ניתן לפתוח את החיפוש בעמוד. נסו שוב.",
    "widget_title": "עוזר AI",
    "widget_open": "פתיחת עוזר ה-AI",
    "widget_close": "מזעור עוזר ה-AI",
    "widget_new_reply": "תשובה חדשה מעוזר ה-AI",
    "voice": {
      "record": "הקלטת הודעה קולית",
      "stop": "שליחת ההודעה הקולית",
      "cancel": "ביטול ההקלטה",
      "recording": "מקליט…",
      "mic_denied": "המיקרופון חסום. אשרו אותו לאתר זה בדפדפן ונסו שוב.",
      "unsupported": "הודעות קוליות אינן נתמכות בדפדפן זה.",
      "not_understood": "לא הצלחתי להבין את ההודעה. נסו שוב.",
      "error": "לא ניתן לעבד את ההודעה הקולית. נסו שוב.",
      "limit": "יותר מדי הודעות קוליות. נסו שוב מאוחר יותר."
    },
    "feedback": {
      "open": "דרגו את התשובה",
      "sent": "המשוב נשלח. לחצו כדי לשנות",
      "title": "המשוב שלך",
      "q_understood": "הבין את הבקשה?",
      "q_correct": "המידע נכון?",
      "q_helped": "עזר להתקדם?",
      "yes": "כן",
      "no": "לא",
      "placeholder": "משהו נוסף? (לא חובה)",
      "send": "שליחה",
      "sending": "שולח…",
      "thanks": "תודה על המשוב!",
      "error": "לא ניתן היה לשלוח את המשוב. נסו שוב.",
      "close": "סגירה",
    },
    "viewer": {
      "title": "עוזר AI · מציג שיחות",
      "close": "סגור",
      "company": "חברה",
      "department": "מחלקה",
      "branch": "סניף",
      "user": "משתמש",
      "status": "סטטוס",
      "from": "מתאריך",
      "to": "עד תאריך",
      "search": "חיפוש",
      "search_placeholder": "מזהה שיחה או מילים מהצ׳אט",
      "all_companies": "כל החברות",
      "all_departments": "כל המחלקות",
      "all_branches": "כל הסניפים",
      "all_users": "כל המשתמשים",
      "all_statuses": "כל הסטטוסים",
      "reset": "איפוס",
      "refresh": "רענון",
      "col_started": "התחלה",
      "col_last": "פעילות אחרונה",
      "col_user": "משתמש",
      "col_company": "חברה",
      "col_department": "מחלקה",
      "col_branch": "סניף",
      "col_messages": "הודעות",
      "col_status": "סטטוס",
      "col_first_message": "הודעה ראשונה",
      "empty": "אין שיחות שמתאימות למסננים.",
      "error": "לא ניתן לטעון את השיחות. נסו שוב.",
      "forbidden": "רק צוות BePro יכול לפתוח את מציג השיחות.",
      "rows_per_page": "שורות בעמוד",
      "range": "{{from}}–{{to}} מתוך {{total}}",
      "prev": "העמוד הקודם",
      "next": "העמוד הבא",
      "details": "שיחה",
      "locale": "שפה",
      "search_id": "מזהה חיפוש",
      "tokens": "טוקנים",
      "tokens_short": "טוקנים",
      "feedback_filter": "משוב",
      "col_feedback": "משוב",
      "col_tokens": "טוקנים נשלחו / התקבלו",
      "tokens_in_out_hint": "טוקנים שנשלחו למודל / התקבלו ממנו",
      "feedback_open": "הצגת המשוב",
      "feedback_title": "משוב",
      "feedback_open_session": "פתיחת השיחה",
      "feedback_empty": "אין משוב בשיחה זו.",
      "feedback_like": "אהבו",
      "feedback_dislike": "לא אהבו",
      "feedback_comment": "הערה בלבד",
      "feedback_comment_label": "הערה",
      "feedback_no_text": "ללא הערה",
      "feedback_q_understood": "הבין את הבקשה",
      "feedback_q_correct": "המידע נכון",
      "feedback_q_helped": "עזר להתקדם",
      "feedback_yes": "כן",
      "feedback_no": "לא",
      "feedback_unanswered": "—",
      "feedback_question": "שאלת המשתמש",
      "feedback_answer": "תשובת העוזר",
      "feedback_copy": "העתקה עבור המפתח",
      "feedback_copy_header": "משוב על עוזר ה-AI",
      "feedback_rating": "דירוג",
      "feedback_date": "תאריך",
      "conversation": "השיחה",
      "tool_calls": "קריאות לכלים",
      "show_tools": "הצג קריאות לכלים",
      "blocked_by_guard": "נחסם על ידי המגן",
      "failed_calls": "קריאות שנכשלו",
      "role_user": "משתמש",
      "role_assistant": "עוזר",
      "role_system": "מערכת",
      "input": "קלט",
      "error_detail": "שגיאה",
      "no_messages": "אין עדיין הודעות בשיחה הזו."
    }
  },
  "package": {
    "package": "חבילה",
    "s": "חבילות נופש",
    "type": "סוג",
    "destination": "יעד",
    "room_type": "סוג החדר",
    "tours": "טיול מאורגן",
    "depart": "יציאה",
    "return": "חזרה",
    "price_per_person": "מחיר לאדם",
    "total_price": "מחיר לעסקה",
    "deal_features": "מאפיינים",
    "nights": "מס' לילות",
    "nts": "לילות",
    "package_type": "סוג החבילה",
    "occupancy": "הרכב",
    "details": "פרטי החבילה",
    "category": "קטגוריה",
    "taxes": "מיסים",
    "per_person": "ממוצע/חבילה",
    "board_type": "בסיס אירוח",
    "country": "מדינה",
    "language": "שפה",
    "including": "כולל",
    "not_including": "לא כולל",
    "more_info": "מידע נוסף",
    "terms_of_cancellation": "תנאי ביטול",
    "important_info": "חשוב לדעת!",
    "it_is_your_res": "באחריותך לקרוא את ",
    "terms_of_use": "תנאי השימוש באתר ",
    "and_all_conditions": " באתר ואת כל התנאים וההגבלות לגבי הזמנתך",
    "general_conditions": "תנאים כלליים וביטולים",
    "alphabetically": "לפי א\"ב",
    "popular": "יעדים פופולריים",
    "per_trip": "לכל הנסיעה",
    "provider": "ספק",
    "flight": "פרטי טיסה",
    "select_num_pax": "בחר מספר נוסעים",
    "supplier_terms": "תנאי הספק",
    "immediate_approval": "אישור מיידי",
    "please_select_flight": "נא לבחור טיסה",
    "status_go_to_m_or_req_1": "הזמנה מס': {{number}} הועברה לאישור הספק .",
    "status_go_to_m_or_req_2": "עם אישור סופי של ההזמנה, יישלח אליך מייל נוסף ובו פרטי ההזמנה המאושרים.",
    "you_need_to_choose_room_first": "יש לבחור חדר קודם",
    "catalog_additional_payments": "תשלומים נוספים בקטלוג",
    "sorry_we_couldnt_locate_item": "מצטערים, לא הצלחנו לאתר את הפריט.",
    "room_no": "מס' חדר",
    "complect": "הרכב",
    "room_type_accommodation_base": "סוג חדר + בסיס אירוח",
    "add_room_to_reservation": " הוסף חדר להזמנה",
    "room_selection": "בחירת חדר"
  },
  "tour": {
    "tour": "טיול",
    "s": "טיולים מאורגנים"
  },
  "NOFSHON": "נופשון",
  "LOWCOST": "לואוקוסט",
  "CITY": "חבילת עיר",
  "SPA": "ספא",
  "KOSHER": "כשר",
  "Water Park": "סולם מים",
  "SPA MEDICAL": "ספא מדיקלי",
  "close": "סגור",
  "more": "עוד",
  "less": "פחות",
  "actions": "פעולות",
  "all": "הכל",
  "apply": "ליישם",
  "apply_2": "לאשר",
  "choose": "בחר",
  "from": "מ",
  "to": "ל",
  "type": "סוג",
  "at": "ב",
  "km": "ק\"מ",
  "name": "שם",
  "price": "מחיר",
  "original_price": "מחיר מקורי",
  "reset": "איפוס",
  "continue": "המשך",
  "total": "סה״כ",
  "basis": "בסיס",
  "taxes": "מיסים",
  "back": "חזור",
  "days_sm": "ימים",
  "hours_sm": "ש'",
  "minutes_sm": "ד'",
  "confirm": "אישור",
  "title": "כותרת",
  "male": "זכר",
  "female": "נקבה",
  "child": "ילד",
  "success": "הצלחה",
  "failed_order": "הזמנה נכשלה. נא להתקשר לתמיכה",
  "error": "שגיאה",
  "notes": "הערות",
  "note": "הערה",
  "show_less": "הצג פחות",
  "show_more": "הצג עוד",
  "show_all": "הצג הכל",
  "no_entries": "אין רשומות",
  "best": "מומלץ",
  "day": "יום",
  "ok": "בסדר",
  "of": "של",
  "add": "הוסף",
  "save": "שמור",
  "yes": "כן",
  "delete": "מחק",
  "order_created_successfully": "ההזמנה נוצרה בהצלחה",
  "session_expired_try_again": "ההפעלה שלך פגה. נסה שוב",
  "cancel": "בטל",
  "change_choice": "שנה בחירה",
  "click_here": "לחץ כאן",
  "details": "פרטים",
  "clear": "נקה",
  "clear_all": "נקה הכל",
  "REG": "רגיל",
  "pay_wait": "אנא המתן...",
  "pay_wait_text": "ההזמנה שלך בעיבוד",
  "pay_processing": "מעבד תשלום...",
  "normal": "רגיל",
  "credit": "אשראי",
  "only_english_input": "נא למלא שם פרטי ושם משפחה באנגלית כפי שמופיע בדרכון",
  "nights": "לילות",
  "something_went_wrong": "משהו השתבש",
  "accessibility": "נגישות",
  "payment_error": "התשלום נכשל.",
  "MultipleDestinations": "ריבוי יעדים",
  "RoundTrip": "הלוך חזור",
  "OneWay": "כיוון אחד",
  "eEconomyClass": "תיירים",
  "eEconomyPlusClass": "מחלקה פרימיום",
  "eBusinessClass": "עסקים",
  "rules": "כללים",
  "click_for_details": "לחצו לפרטים",
  "TRAVELFUSION": "LOW",
  "ro": "חדר בלבד",
  "bb": "ארוחת בוקר",
  "fb": "כל כפול",
  "ai": "כל כפול",
  "show_cancellation_date": "הצג תאריך ביטול",
  "cancellation_date_delta": "הפרש ימים לתאריך ביטול",
  "add_to": "הוסף להצעה",
  "max_images_selected": "ניתן לבחור עד 3 תמונות",
  "ai_hotel_info": "מידע מלון AI",
  "claude": {
    "pets": "חיות מחמד",
    "cancellation": "ביטול",
    "adults_only": "למבוגרים בלבד",
    "website": "אתר אינטרנט",
    "notes": "הערות",
    "pros": "יתרונות",
    "cons": "חסרונות",
    "pros_cons": "יתרונות וחסרונות",
    "not_found": "המלון לא נמצא"
  },
  "login": {
    "login": "התחברות",
    "login_your": "התחבר לחשבון שלך",
    "username": "קוד משתמש",
    "password": "סיסמה",
    "success": "נכנסת בהצלחה",
    "off_success": "התנתקת בהצלחה",
    "error": "שם משתמש או סיסמה שגויים",
    "off": "התנתק",
    "contact_us": "צור קשר",
    "get_back": "תחזרו אליי",
    "select_number": "מספר נוסעים",
    "full_name": "שם מלא",
    "contact_us_success": "הפנייה נשלחה בהצלחה",
    "contact_us_error": "שגיאה בשליחת הפנייה",
    "as": "מחובר כ",
    "usercode": "קוד משתמש"
  },
  "validation": {
    "numbers": "רק מספרים מותר",
    "email": "דואר אלקטרוני שגוי",
    "required": "השדה הוא חובה",
    "minLength": "השדה חייב להכיל {1} תווים או יותר",
    "maxLength": "השדה חייב להכיל {1} תווים או פחות",
    "length": "השדה חייב להכיל {1} תווים",
    "english": "מותר להכניס רק תווים אנגליים"
  },
  "mo": {
    "mo": "ההזמנות שלי",
    "segment_gross_edited": "קטע גרוס נערך בהצלחה",
    "logs": "יומנים",
    "open_log": "פתח יומן",
    "table_settings": "הגדרות טבלה",
    "support_ticket": "כרטיס תמיכה",
    "support_ticket_success": "כרטיס תמיכה נוצר בהצלחה",
    "subject": "נושא",
    "reply": "תגובה",
    "ticket": "כרטיס",
    "ticket_updated": "כרטיס עודכן בהצלחה",
    "segment_id": "מספר קטע",
    "order_id": "מספר הזמנה",
    "order": "הזמנה",
    "supplier_pnr": "PNR של ספק",
    "local": "מקומי",
    "backoffice_id": "מספר זיהוי באחסון מקדימה",
    "passenger_name": "שם הנוסע",
    "creation_date": "תאריך יצירה",
    "orders": "הזמנות",
    "segment": "קטע",
    "segment_full": "קטע",
    "docket": "קבלה",
    "pnr": "PNR",
    "start": "התחלה",
    "name": "שם",
    "dest": "יעד",
    "items": "פריטים",
    "clx": "CLX",
    "status": "ס",
    "voucher": "שובר",
    "quantity": "כמות",
    "total": "סה\"כ",
    "pay": "תשלום",
    "supplier": "ספק",
    "end": "סיום",
    "agent": "סוכן",
    "branch": "סניף",
    "order_details": "פרטי הזמנה",
    "check_in": "צק אין",
    "check_out": "צק אאוט",
    "nights": "לילות",
    "date_c": "תאריך יצירה",
    "segment_details": "פרטי קטע",
    "paxes": "נוסעים",
    "legs": "רגליים",
    "class": "מחלקה",
    "date_time": "תאריך ושעה",
    "arrival": "הגעה",
    "status_full": "סטטוס",
    "pnr_ref": "קישור PNR",
    "supplier_full": "ספק",
    "emergency_phone": "טלפון חירום",
    "support_email": "דוא\"ל תמיכה",
    "emergency_email": "דוא\"ל חירום",
    "amount": "סכום",
    "gross": "גרוס",
    "coupon_code": "קוד קופון",
    "total_gross": "סה\"כ גרוס",
    "total_net": "סה\"כ נטו",
    "disc_coupon": "הנחה קופון",
    "vat": "מע\"מ",
    "total_due": "סה\"כ לתשלום",
    "client_id": "מזהה לקוח",
    "discount": "הנחה",
    "comission": "עמלה",
    "profit": "רווח",
    "remarks": "הערות",
    "remark": "הערה",
    "info": "מידע",
    "remark_code": "קוד",
    "order_seg_remark_id": "מזהה הערת הזמנה קטע",
    "desc": "הודעה",
    "user": "משתמש",
    "dateC": "תאריך יצירה",
    "depatment": "מחלקה",
    "voucher_full": "שובר",
    "print_voucher": "הדפסת שובר",
    "voucher_number": "מספר שובר",
    "backoffice_voucher_identity_number": "מספר זיהוי שובר באחסון מקדימה",
    "status_the_same": "הסטטוס נשאר זהה",
    "status_changed": "הסטטוס השתנה ל{{status}}",
    "current_status": "הסטטוס הנוכחי",
    "product_type": "סוג המוצר",
    "back_to_orders": "חזרה להזמנות",
    "cancel_order": "בטל הזמנה",
    "segments": "קטעים",
    "booking_about_to_cancel": "ההזמנה הזו עומדת להיבוטל.",
    "are_you_sure": "האם אתה בטוח?",
    "order_cancelled": "ההזמנה בוטלה בהצלחה. הסטטוס שונה ל{{status}}",
    "hello": "היי",
    "user_code": "קוד משתמש",
    "department": "מחלקה",
    "loading": "טוען...",
    "supp": "ספק",
    "pnr_to_docket": "PNR לדו\"ח",
    "docket_success": "הדו\"ח נשמר בהצלחה",
    "clipboard_success": "הנתונים הועתקו ללוח",
    "no_data_found": "לא נמצאו נתונים",
    "room_preferences": "העדפות חדר",
    "guest_notes": "הערות אורח",
    "additional_requirements": "דרישות נוספות",
    "please_double_bed": "אם אפשר, נא לאשר חדר עם <b>מיטה זוגית</b>",
    "please_twin_beds": "אם אפשר, נא לאשר חדר עם <b>שתי מיטות יחיד</b>",
    "please_high_floor": "אם אפשר, נא לאשר חדר בקומה <b>גבוהה</b>",
    "please_low_floor": "אם אפשר, נא לאשר חדר בקומה <b>נמוכה</b>",
    "please_non_smoking": "אם אפשר, נא לאשר חדר <b>ללא עישון</b>",
    "please_smoking": "אם אפשר, נא לאשר חדר <b>למעשנים</b>",
    "please_adjoining_room": "אם אפשר, נא לאשר חדר <b>צמוד</b>",
    "please_connecting_rooms": "אם אפשר, נא לאשר <b>חדרים מחוברים</b>",
    "please_quiet_room": "אם אפשר, נא לאשר חדר <b>שקט</b>",
    "please_bathtub": "אם אפשר, נא לאשר חדר עם <b>אמבטיה</b>",
    "please_accessible_room": "אם אפשר, נא לאשר חדר <b>נגיש</b> או <b>מותאם לנכים</b> עם <b>מקלחון ללא מדרגה</b> (הלקוח משתמש בכיסא גלגלים)",
    "note_late_arrival": "נא לשים לב שהאורח יגיע <b>מאוחר (אחרי 19:00)</b>",
    "confirm_early_arrival": "נא לאשר <b>הגעה מוקדמת</b> בשעה משוערת: ______",
    "confirm_late_arrival": "נא לאשר <b>הגעה מאוחרת</b> בשעה משוערת: ______",
    "confirm_late_checkout": "נא לאשר <b>עזיבה מאוחרת</b> בשעה משוערת: ______",
    "note_no_voucher": "נא לשים לב: <b>האורח יגיע ללא שובר</b>",
    "note_honeymoon": "נא לשים לב: <b>הנוסעים בחופשת ירח דבש</b>",
    "confirm_baby_cot": "אם אפשר, נא לאשר <b>עריסת תינוק</b> עבור:<br>שם מלא: _____________ תאריך לידה: __________",
    "add_confirm_baby_cot": "נא להוסיף תינוק לחדר, אם אפשר, ולאשר עריסת תינוק עבורו: <br>שם מלא: __________ תאריך לידה: __________",
    "if_child": "זה במידה והתינוק בהזמנה",
    "if_no_child": "במידה והוא לא בהזמנה",
    "please_enter_info_about_baby": "נא להזין מידע על התינוק",
    "change_request": "בקשה מיוחדת",
    "change_request_success": "הבקשה המיוחדת נשלחה בהצלחה",
    "choose_requests_can_edit": "בחר/י בקשה (בקשות) מהרשימה. ניתן לערוך את טקסט הבקשה כאן.",
    "order_information": "הזמנה - מידע",
    "order_public_price": "הזמנה - מחיר לציבור",
    "order_send_order_email": "הזמנה - שליחת דוא\"ל הזמנה",
    "order_agent": "הזמנה - סוכן",
    "order_operator": "הזמנה - מפעיל",
    "print": "הדפס",
    "send": "שלח",
    "print_file_generated": "הקובץ נוצר בהצלחה",
    "documents": "מסמכים",
    "file_name": "שם קובץ",
    "file_type": "סוג קובץ",
    "tran_id": "מספר עסקה",
    "ptr_id": "מזהה PTR",
    "reason": "סיבה",
    "token": "אסימון",
    "p": "P",
    "a": "A",
    "t": "T",
    "err_code": "קוד שגיאה",
    "payments": "תשלומים",
    "order_report": "דוח הזמנה",
    "order_report_sent_success": "דוח הזמנה נשלח בהצלחה",
    "send_to_me": "שלח לי {{email}}",
    "thin_report": "דוח דק",
    "email_success": "האימייל נשלח בהצלחה",
    "voucher_type": "סוג שובר",
    "regular_voucher": "שובר רגיל",
    "thin_voucher": "שובר דק",
    "display_order": "הצג הזמנה",
    "issue_voucher": "הנפק שובר",
    "copied": "הטקסט הועתק",
    "link_copied": "הקישור הועתק",
    "send_support_message": "שלח הודעת תמיכה",
    "send_support_message_success": "ההודעה נשלחה בהצלחה",
    "add_comission": "הוספת עמלה",
    "item": "פריט",
    "search_again": "חפש שוב",
    "download_success": "ההורדה הושלמה",
    "units": "יחידות",
    "order_list_report": "דוח רשימת הזמנות",
    "order_list_report_no_names": "דוח רשימת הזמנות - ללא שמות",
    "order_list_report_by_param": "דוח רשימת הזמנות לפי פרמטר",
    "order_list_report_by_dest": "דוח רשימת הזמנות לפי יעד",
    "summary_report_by_department": "דוח סיכום לפי מחלקה",
    "summary_report_by_branch": "דוח סיכום לפי סניף",
    "summary_report_by_supplier": "דוח סיכום לפי ספק",
    "orders_by_branch": "הזמנות לפי סניף",
    "orders_by_currency": "הזמנות לפי מטבע",
    "orders_by_supplier": "הזמנות לפי ספק",
    "export_to_file": "ייצוא לקובץ",
    "export_to_file_no_names": "ייצוא לקובץ - ללא שמות",
    "export_to_file_refund": "ייצוא לקובץ - החזר כספי",
    "refund_report": "דוח החזרים",
    "coupon_report": "דוח קופונים",
    "report_price": "מחיר דוח",
    "public_price": "מחיר ציבורי",
    "sys_total_agent": "סה\"כ מערכת - סוכן",
    "sys_nett_operator": "נטו מערכת - מפעיל",
    "report_type": "סוג דוח",
    "report": "דוח",
    "report_generated": "הדוח נוצר בהצלחה",
    "currency": "מטבע",
    "tour_subject": "נושא הסיור",
    "add_remark": "הוסף הערה",
    "remark_added": "ההערה נוספה בהצלחה",
    "ticket_number": "מספר כרטיס",
    "public": "ציבורי",
    "private": "אישי",
    "body": "גוף",
    "support_update": "עדכון כרטיס",
    "support_update_success": "כרטיס עודכן בהצלחה",
    "itinerary": "מסלול",
    "include": "כלול",
    "not_included": "לא כלול",
    "information": "מידע",
    "start_price": "החל מ-",
    "change_user": "שינוי משתמש",
    "change_user_success": "המשתמש שונה בהצלחה",
    "current_user": "משתמש נוכחי",
    "data_saved": "נתונים נשמרו בהצלחה",
    "agency": "סוכן",
    "currencies": "מטבעות",
    "upload_logo": "העלאת לוגו",
    "current_logo": "לוגו נוכחי",
    "new_logo": "לוגו חדש",
    "last_update": "תאריך עדכון אחרון",
    "city": "עיר",
    "branch_title": "שם סניף",
    "display_cancellation_policy": "הצג מדיניות ביטול",
    "download": "הורד",
    "documents_uploaded_successfully": "{{count}} קבצים נטענו בהצלחה",
    "no_files_selected": "לא נבחרו קבצים",
    "choose_files": "בחר קבצים",
    "delete_document": "מחיקת קובץ",
    "document_deleted": "קובץ נמחק בהצלחה",
    "all_departments": "כל המחלקות",
    "all_branches": "כל הסניפים",
    "profile": "פרופיל",
    "set_different_user": "הגדר משתמש שונה",
    "login_as": "התחבר כמשתמש",
    "username": "שם משתמש",
    "reset": "איפוס",
    "logged_as_user_successfully": "התחברת כמשתמש בהצלחה",
    "logged_as_user_reset_successfully": "התנתקת כמשתמש בהצלחה",
    "add_payment": "הוספת תשלום"
  },
  "destination": {
    "s_our_top": "יעדים מומלצים שלנו"
  },
  "search": {
    "new": "חיפוש חדש",
    "remember_mode_enabled": "מצב זיכרון פעיל",
    "open_details_in_new_tab": "פתיחת פרטים בלשונית חדשה",
    "your_latest_searches": "החיפושים האחרונים שלך",
    "radius": "רדיוס",
    "no_results": "לא נמצאו תוצאות",
    "destination": "יעד",
    "check_in": "תאריך כניסה",
    "check_out": "תאריך יציאה",
    "max_occupancy": "מספר נוסעים",
    "rooms": "חדרים",
    "room": "חדר",
    "star_rating": "דירוג כוכבים",
    "nationality": "אזרחות",
    "adults": "מבוגרים",
    "children": "ילדים",
    "youths": "צעירים",
    "seniors": "פנסיונר",
    "infants": "תינוקות",
    "adult": "מבוגר",
    "child": "ילד",
    "youth": "צעיר",
    "senior": "פנסיונר",
    "infant": "תינוק",
    "under": "עד",
    "add_room": "הוסף חדר",
    "search": "חיפוש",
    "max_persons": "מספר מרבי של אנשים: {{count}}",
    "infants_warning": "ספירת תינוקות חייבת להיות פחות ממבוגרים",
    "history": "היסטוריית חיפוש",
    "age": "גיל ילד (2-16)",
    "suppliers": "ספקים",
    "with_active_filters": "עם סננים פעילים",
    "display_exactly": " הצג בדיוק",
    "search_type_id": "מזהה סוג חיפוש"
  },
  "sort": {
    "er": "מיון",
    "by": "מיין לפי",
    "price_increase": "מחיר: נמוך עד גבוה",
    "price_decrease": "מחיר: גבוה עד נמוך",
    "cxl_increase": "CXL: נמוך עד גבוה",
    "cxl_decrease": "CXL: גבוה עד נמוך",
    "airline_increase": "חברת תעופה: (A - Z)",
    "airline_decrease": "חברת תעופה: (Z - A)",
    "star_increase": "כוכב: נמוך עד גבוה",
    "star_decrease": "כוכב: גבוה עד נמוך",
    "hotel_increase": "כוכב: (A - Z)",
    "hotel_decrease": "מלון: (Z - A)",
    "duration_increase": "אורך: נמוך עד גבוה",
    "duration_decrease": "אורך: גבוה עד נמוך",
    "departure_outbound_increase": "ההמראה המוקדמת ביותר ({{dep}})",
    "departure_outbound_decrease": "ההמראה האחרונה ({{dep}})",
    "returning_outbound_increase": "הנחיתה המוקדמת ביותר ({{arr}})",
    "returning_outbound_decrease": "הנחיתה האחרונה ({{arr}})",
    "departure_inbound_increase": "ההמראה המוקדמת ביותר ({{arr}})",
    "departure_inbound_decrease": "ההמראה האחרונה ({{arr}})",
    "returning_inbound_increase": "הנחיתה המוקדמת ביותר ({{dep}})",
    "returning_inbound_decrease": "הנחיתה האחרונה ({{dep}})",
    "recommended": "מומלץ",
    "distance": "מרחק",
    "distance_increase": "מרחק: (0 - 100)",
    "distance_decrease": "מרחק: (100 - 0)",
    "name": "שם",
    "star": "כוכב"
  },
  "group": {
    "gr": "קבוצה",
    "special": "מיוחד",
    "group": "בקשות מיוחדת",
    "request": "בקשות מיוחדת",
    "request_type": "סוג בקשה",
    "hotel": "מלון",
    "flight": "טיסה",
    "destination": "יעד",
    "hotel_name": "שם המלון",
    "room_type": "סוג חדר",
    "double": "כפול",
    "single": "יחיד",
    "triple": "משולש",
    "quadro": "מרובע",
    "group_type": "סוג בקשה",
    "hotel_stars": "כוכבי מלון",
    "stars_5": "5 כוכבים",
    "stars_4": "4 כוכבים",
    "stars_3": "3 כוכבים",
    "stars_2": "2 כוכבים",
    "star_1": "1 כוכב",
    "number_of_rooms": "מספר חדרים",
    "check_in": "צ׳ק אין",
    "check_out": "צ׳ק אאוט",
    "contact_information": "פרטי יצירת קשר",
    "agency_name": "שם הסוכנות",
    "agent_fn": "שם פרטי של הסוכן",
    "agent_ln": "שם משפחה של הסוכן",
    "agent_email": "דוא\"ל של הסוכן",
    "agent_phone": "טלפון של הסוכן",
    "message": "הודעה",
    "send_request": "שלח בקשה",
    "request_sent": "הבקשה נשלחה בהצלחה",
    "from": "מ",
    "to": "אל",
    "date": "תאריך",
    "flight_time": "שעת טיסה",
    "airline": "חברת תעופה",
    "number_of_passengers": "מספר נוסעים"
  },
  "filter": {
    "filter": "מסנן",
    "s": "מסננים",
    "stops": "עצירות",
    "stop": "עצירה",
    "stop_up": "עצירה",
    "stops_sm": "עצירות",
    "direct_flight": "רק טיסות ישירות",
    "direct_flights": "רק טיסות ישירות",
    "direct_flights_outbound": "טיסות ישירות - כיוון הלוך",
    "one_stop": "עצירה 1",
    "two_or_more_stops": "2+ עצירה",
    "reset": "אפס בחירה",
    "price_range": "טווח מחירים",
    "times": "פעמים",
    "takeoff": "ההמראה",
    "landing": "נחיתה",
    "duration": "משך זמן",
    "free_text": "טקסט חיפוש",
    "stop_duration": "משך העצירה",
    "airlines": "חברות תעופה",
    "airports": "שדות תעופה",
    "by_name": "שם מלון",
    "by_rooms": "שם חדר",
    "by_stars": "כוכבים",
    "by_prices": "מחיר",
    "search_by_location": "מיקום",
    "more": "סינונים נוספים",
    "free_cancellation": "ביטול חינם",
    "board": "בסיס אירוח",
    "clear": "נקה מסננים",
    "baggage": "כבודה",
    "baggage_included": "כולל המטען",
    "baggage_not_included": "המטען אינו כלול",
    "meal": "ארוחה",
    "airline": "חברת תעופה",
    "free_x": "ביטול חינם",
    "is_less_than": "פחות מ",
    "is_greater_than": "יותר מ",
    "free": "חינם ...",
    "preffered_hotels": "מלונות מועדפים",
    "breakfast": "ארוחת בוקר",
    "half_board": "חצי פנסיון",
    "full_board": "פנסיון מלא",
    "all_inclusive": "הכל כלול",
    "max_price": "מקסימלי",
    "min_price": "מינימלי",
    "max": "מקסימלי",
    "min": "מינימלי"
  },
  "home": {
    "home": "בית",
    "session_expired": "הפעלה פגה",
    "session_expired_desc": "ההפעלה שלך פגה. נסה לחפש שוב",
    "go_back": "חזור הביתה",
    "search_out_of_date": "תוצאות החיפוש עשויות להיות לא מעודכנות",
    "please_refresh": "אנא, רענן את תוצאות החיפוש",
    "refresh_results": "רענן את התוצאות",
    "new_search": "חיפוש חדש",
    "confirmation_dialog": "דיאלוג אישור",
    "password": "סיסמה",
    "wrong_password": "סיסמה שגויה",
    "failed_to_pay": "כישלון ביצירת ההזמנה, ההזמנה בוטלה במהלך תהליך ההזמנה. אנא נסה שוב."
  },
  "passenger": {
    "as_client": "כלומר לקוח",
    "as_agent": "כלומר סוכן",
    "details": "פרטי הנוסעים",
    "important_notes": "הערות חשובות",
    "apartment_notes": "אנא שים לב: בית מלון אינו זמין בחדרים מסוימים. כניסה מקוונת, וקודי גישה נשלחים מראש.",
    "passenger": "נוסע",
    "s": "נוסעים",
    "guest": "אורח",
    "guests": "אורחים",
    "gender": "מגדר(מין)",
    "male": "זכר",
    "female": "נקבה",
    "ln": "שם משפחה",
    "fn": "שם פרטי",
    "dob": "תאריך לידה",
    "phone": "טלפון",
    "email": "דוא\"ל",
    "confirm": "אנא אשר כי אתה מסכים לתנאים",
    "read_more": "קרא עוד",
    "attention": "ההזמנה הנה תחת דמי ביטול",
    "order_details": "פרטי ההזמנה",
    "cancellation_details": "פרטי ביטול",
    "cancellation_date": "ניתן לבטל עד",
    "cancellation_outdate": "לא ניתן לבטל. דמי ביטול מלאים",
    "booking_summary": "סיכום הזמנה",
    "room_count": "כמות חדרים",
    "confirm_order": "אשר את הפקודה",
    "room": "חדר",
    "optional_services": "שירותים אופציונליים (כבודה & ארוחות)",
    "methods_of_payment": "אמצעי תשלום",
    "fast_secure": "תשלום מאובטח ומהיר בכרטיס אשראי",
    "transaction_type": "סוג עסקה",
    "number_of_payments": "מספר תשלומים",
    "send_request_to_consultant": "שלח בקשה לטיפול יועץ הנסיעות",
    "green_button_tooltip": "שלח בקשה לטיפול יועץ הנסיעות",
    "send_request": "שלח בקשה",
    "rule_display": "תצוגת כללים",
    "rule_i": "חוק {{i}}. {{fareBase}} | {{airlineCode}} | {{departureCode}}-{{arrivalCode}}",
    "message": "הודעה",
    "birthday": "יום הולדת",
    "years": "שנים",
    "confirm_order_text": "אשר הזמנת ספר",
    "mr": "גבר",
    "mrs": "גברת",
    "miss": "פספוס",
    "ms": "גברת",
    "dr": "ד\"ר",
    "prof": "פרופסור",
    "title": "כותרת",
    "phone_country": "קידומת",
    "add": "הוסף נוסע",
    "passport_valid_till": "פסקול תקף עד",
    "passport": "פסקול",
    "price_for_single_in_composition_for_double": "מחיר לאדם בהרכב  זוגי",
    "order_id": "מספר הזמנה",
    "id_number": "מספר זהות",
    "cancel_order_success": "נשלח בהצלחה",
    "city": "עיר",
    "branch_title": "שם סניף",
    "display_cancellation_policy": "הצג מדיניות ביטול",
    "please_wait": "אנא המתן...",
    "your_payment_is_being_processed": "התשלום נעשה בהצלחה",
    "fast_secure_multi_payment": "תשלום מאובטח ומהיר בע {{count}} כרטיסי אשראי",
    "procces_with_revolut": "לעבד ב־Revolut",
    "pay": "לשלם",
    "every_hotel_has_room": "כל מלון חייב להיות עם חדר"
  },
  "access": {
    "accessibility_settings": "הגדרות נגישות",
    "internet_accessibility": "נגישות האינטרנט אומר שאנשים עם מוגבלות יכולים להשתמש באינטרנ",
    "contrast": "ניגודיות:",
    "dark": "כהה",
    "normal": "רגיל",
    "bright": "בהיר",
    "color": "צבע:",
    "high": "גבוה",
    "black_white": "שחור-לבן",
    "font_size": "גודל פונט:",
    "clear_selection": "נקה בחירה"
  },
  "deal": {
    "tours": "טיול מאורגן",
    "fly_drive": "טוס וסע",
    "nofshon": "נופשון",
    "ski": "סקי",
    "spa": "ספא",
    "sport": "ספורט",
    "cruise": "קרוז"
  },
  "cookie": {
    "cookie_policy": "מדיניות על פרטיות קובצים",
    "title": "אנו מכבדים את פרטיותך.",
    "text": "אנו משתמשים בקובצי עוגיות כדי לשפר את החווית הנגישה שלך, לספק פרסומות או תוכן מותאם אישית, ולנתח את התעבורה שלנו. על ידי לחיצה על \"אישור הכול\", אתה מסכן לשימוש בקובצי עוגיות שלנו.",
    "accept": "אישור הכול",
    "reject": "הסר הכול"
  }
};
